<!-- CARGADOR -->
<jqxLoader #loader [imagePosition]="'top'" [width]="60" [height]="60" [text]="'Espere...'">
</jqxLoader>

<div class="panel panel-primary my-1 mx-auto rounded-3 shadow-lg" style="height: 99%">
    <div class="panel-heading clearfix">
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-5">
                <div class="panel-title pull-left">
                    <span style="font-size: x-large;">Clonación de menús</span>
                </div>
            </div>
            <div class="col-md-3"></div>
        </div>
    </div>

    <!-- FILTROS -->
    <div class="m-2 p-2 rounded-3 borderFilter" style="height: 50px;">
    </div>

    <!-- TABLA GRID -->
    <div class="m-4 row" style="height: 85%;">

        <div class="col-3">
            <h4>Origen</h4>
            <jqxDropDownList #cbMenuOri [width]="302" [height]="25" [selectedIndex]="0"
                (onSelect)="onChangeMenuOri($event)">
            </jqxDropDownList>
            <jqxTree #menuOrigin [theme]="environment.tema" [width]="300" [height]="460" [source]="recordsOri"
                [hasThreeStates]="false" [checkboxes]="false" [allowDrag]="true" [allowDrop]="true"
                (onDragStart)="dragStartOrigin($event)" (onDragEnd)="dragEndOrigin($event)">
            </jqxTree>
        </div>

        <div class="col-3">
            <h4>Final</h4>
            <jqxTree #menuFinal [theme]="environment.tema" [width]="300" [height]="485" [source]="recordsFin"
                [hasThreeStates]="false" [checkboxes]="false" [allowDrag]="true" [allowDrop]="true"
                (onDragStart)="dragStartFinal($event)" (onDragEnd)="dragEndFinal($event)">
            </jqxTree>
        </div>

        <div class="col-2">
            <h4>&nbsp;</h4>
            Nombre
            <jqxInput #ebNombre [width]="500" [height]="25">
            </jqxInput>
            Observaciones
            <jqxInput #ebObserv [width]="500" [height]="25">
            </jqxInput><br><br>
            <jqxButton style="margin-top: 30px; float: left;" [theme]="environment.tema" [imgSrc]='"/assets/images/save.png"'
                [width]='140' [height]='26' [value]="'Crear menú'" (onClick)="onCrear()">
            </jqxButton>
        </div>

    </div>
</div>